/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseSubmissionData } from './genericApiResponseSubmissionData';
import type { GenericApiResponseSubmissionMessage } from './genericApiResponseSubmissionMessage';
import type { GenericApiResponseSubmissionPagination } from './genericApiResponseSubmissionPagination';
import type { GenericApiResponseSubmissionError } from './genericApiResponseSubmissionError';

export interface GenericApiResponseSubmission {
  data?: GenericApiResponseSubmissionData;
  message?: GenericApiResponseSubmissionMessage;
  pagination?: GenericApiResponseSubmissionPagination;
  error?: GenericApiResponseSubmissionError;
  statusCode?: number;
}
